import { ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { recordModel } from "./recordModel";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        onReset,
        loadData
    } = recordModel();

    const onSearch = (val = {}) => {
        loadData({ pageNum: 1 }, { ...searchParam, ...val })
    }

    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "客户名称",
            fieldName: "name",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "单据编号",
            fieldName: "tradeCode",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "开票状态",
            fieldName: "invoiceStatus",
            size: "small",
            disabled: false,
            options: [{ label: "未开票", value: "0" }, { label: "已开票", value: "1" }],
            ...searchProp
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "发票号码",
            fieldName: "invoiceNum",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 4,
            span: 4,
            placeholder: ["开始", "结束"],
            fieldName: "time",
            size: "small",
            disabled: false,
            ...searchProp,
            onChange: (data) => {
                let newData = {
                    billTimeRange: data.time[0] !== '' && data.time[1] !== '' ? {
                        startTime: data.time[0] + ' 00:00:00',
                        endTime: data.time[1] + ' 23:59:59'
                    } : undefined,
                    ...data
                }
                updateSearchParam(newData)
            }
        },
    ]

    return (
        <YhPageHeader
            title="单据发票列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            triggerSearch
            onChange={updateSearchParam}
            handleSearch={onSearch}
            handleReset={onReset}
        />
    );
}